import type { UploadFile } from 'antd';
import { array, mixed, type TestFunction } from 'yup';
import type { UploadFileOutputDto } from './model';

const fileTest: TestFunction<UploadFile<UploadFileOutputDto>[] | undefined> = (
  values,
  ctx,
) => {
  if (!values?.length) {
    return true;
  }

  if (values.some((item) => item.status === 'uploading')) {
    return ctx.createError({
      message: '文件正在上传中，请稍等',
    });
  }

  if (values.every((item) => item.status !== 'done')) {
    return ctx.createError({
      message: '文件上传失败，请重新上传',
    });
  }

  return true;
};

export const fileSchema = array()
  .of(mixed<UploadFile<UploadFileOutputDto>>().required())
  .test(fileTest)
  .nullable();
